import { render, staticRenderFns } from "./MarketplaceBanner.vue?vue&type=template&id=720e11aa&scoped=true"
import script from "./MarketplaceBanner.vue?vue&type=script&lang=js"
export * from "./MarketplaceBanner.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceBanner.vue?vue&type=style&index=0&id=720e11aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e11aa",
  null
  
)

export default component.exports